import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const Art = () => {
  const { isDarkMode } = useTheme();

  return (
    <div className="dashboard-page" style={{ 
      background: isDarkMode ? 'linear-gradient(135deg, #282440 0%, #1a1a2e 100%)' : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      color: isDarkMode ? 'white' : '#333',
      paddingTop: '0'
    }}>
      <div className="container">
        {/* Header Section with Logo and Title */}
        <div style={{ marginBottom: '3rem' }}>
          {/* Centered Title */}
          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <h1 style={{ 
              fontSize: '3rem', 
              fontWeight: 'bold', 
              marginBottom: '1rem',
              color: '#0099FF'
            }}>
              AI-MCP-Bio Artwork
            </h1>
          </div>
          
          {/* Subheader text - centered on the page */}
          <div style={{ 
            marginBottom: '1.5rem'
          }}>
            <p style={{ 
              fontSize: '1.2rem', 
              color: isDarkMode ? '#B0B0B0' : '#666',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: '1.6',
              textAlign: 'center'
            }}>
              Conceptual figure created by AI Google Nano Banana, featuring the integration of artificial intelligence and bioinformatics.
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div style={{
          backgroundColor: isDarkMode ? '#1a1a1a' : '#f8f9fa',
          border: `1px solid ${isDarkMode ? '#333' : '#e9ecef'}`,
          borderRadius: '8px',
          padding: '2rem',
          textAlign: 'center',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '2rem'
          }}>
            <img 
              src={process.env.PUBLIC_URL + '/images/AI-MCP-Bio_Concept.png'} 
              alt="AI-MCP-Bio Conceptual Figure"
              style={{
                maxWidth: '100%',
                height: 'auto',
                maxHeight: '500px',
                borderRadius: '8px',
                boxShadow: isDarkMode 
                  ? '0 4px 16px rgba(0, 0, 0, 0.3)' 
                  : '0 4px 16px rgba(0, 0, 0, 0.1)'
              }}
              onError={(e) => {
                console.error('Image failed to load:', e.target.src);
                e.target.style.display = 'none';
              }}
            />
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <a 
              href={process.env.PUBLIC_URL + '/images/AI-MCP-Bio_Concept.png'} 
              download="AI-MCP-Bio_Concept.png"
              style={{
                backgroundColor: '#0099FF',
                color: 'white',
                padding: '0.75rem 1.5rem',
                borderRadius: '6px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '0.9rem',
                transition: 'all 0.3s ease',
                display: 'inline-block'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#007acc';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = '#0099FF';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              Download
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Art;
